import { Outlet, useLoaderData, useNavigate, useSubmit } from "react-router-dom";
import Header from '../../components/Master/Header';
import Footer from '../../components/Master/Footer';
import { getAuthToken, getLoggedInRoles, getTokenDuration, useAuthenticationState } from "../../Redux/action/setAuthorization";
import { useEffect, useState } from "react";
import * as Constants from "../../Helper/Constants";
import { useDispatch, useSelector } from "react-redux";
import { LOGOUT_SESSION_TIMEOUT } from "../../Redux/actionTypes/AuthActionTypes";
import { CLEAR_REGISTER_REDUCER } from "../../Redux/actionTypes/RegisterActionTypes";
import { getmenudata } from "../../Services/Common/common";
import SidebarMenu from "../../components/Custom/SideBarMenu";
import SupportBodyContent from "../../components/Support/BodyContent";
import { debounce } from "../../Helper/Common";
import { RefreshToken } from "../../Redux/action/AuthAction";
import ModalDialog from "../../components/Custom/ModalDialog";
import SystemsLogin from "../../components/Login/SystemsLogin";
import ForgetPassword from "../../components/Login/ForgetPassword";

function SupportLayout() {
  const loaderData = useLoaderData();
  const [isMobile, setIsMobile] = useState(false);
  const [screenRatio, setScreenRatio] = useState({ 
    height: window.innerHeight,
    width: window.innerWidth
  });
  const [screenOrientation, setScreenOrientation] = useState(window.orientation);
  const [message, setMessage] = useState('');
  const role = getLoggedInRoles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = getAuthToken();
  const submit = useSubmit();
  const authState = useAuthenticationState();
  const [timerId, setTimerId] = useState(null);
  const {isUnAuthorized, isLoggedIn } = useSelector((state) => state.Authentication);
  useEffect(() => {
    const debouncedHandleResize = debounce(function handleResize() {
      setScreenRatio({
        width: window.innerWidth,
        height: window.innerHeight,
      });
    },500)
    
    function checkOrientation(){
      setScreenOrientation(window.orientation);
    }
    window.addEventListener("resize", debouncedHandleResize);
    window.addEventListener('orientationchange', checkOrientation);

    return (_) => {
      window.removeEventListener("resize", debouncedHandleResize);
      window.removeEventListener('orientationchange', checkOrientation);
    };
  });
  useEffect(() => {
    if ((screenRatio.width <= 767 && screenOrientation === 0) || (screenRatio.width <= 1023 && screenOrientation !== 0)) {
      setIsMobile(true);
      setMessage('Access to Systems Account is restricted on mobile devices! Please switch to desktop.');
    } else if ((screenRatio.width <= 1023 && screenOrientation === 0) || (screenRatio.width <= 1180 && screenOrientation !== 0)) {
      setIsMobile(true);
      setMessage('Access to Systems Account is restricted on Tablet devices! Please switch to desktop.');
    } else {
      setIsMobile(false);
      setMessage('');
    }
  }, [screenRatio.height, screenRatio.width]);

  const [open, setOpen] = useState(false);
  const [isForget, setisForget] = useState(false);

  const handleClose = (event, reason) => {
    if (reason && (reason === "backdropClick" || reason === "escapeKeyDown")) 
        return;
    setOpen(false);
  };
  
  useEffect(() => {
    if (!loaderData) {
      setOpen(true);
    }
    else if(loaderData){
      handleClose();
    }
    else if(isUnAuthorized){
      throw {status:403, message: "UnAuthorized Access!"};
    }
  },[loaderData,isUnAuthorized, isLoggedIn]);

  useEffect(() => {
    if (!token) {
      return null;
    }

    if (token === Constants.tokenExpired) {
      submit(null,{action:'/logout',method:'post'});
      dispatch({type:CLEAR_REGISTER_REDUCER});
      dispatch({
        type: LOGOUT_SESSION_TIMEOUT,
            isLoggedIn: false,
            userId: null,
            userInfo: null,
            error: true,
            message: "Token Expired.",
            responseCode: 401
    })
      navigate('/Systems');
    }
    
    if (timerId) {
      clearTimeout(timerId);
    }
    const tokenDuration = getTokenDuration(token);

    const newTimerId = setTimeout(() => {
      submit(null,{action:'/logout',method:'post'});
      dispatch({type:CLEAR_REGISTER_REDUCER});
      dispatch({
        type: LOGOUT_SESSION_TIMEOUT,
            isLoggedIn: false,
            userId: null,
            userInfo: null,
            error: true,
            message: "Token Expired.",
            responseCode: 401
    })
    setTimeout(() => {navigate('/');}, Constants.TimeOutRedirectCounter);
      navigate('/timeout');
    }, tokenDuration);
    setTimerId(newTimerId);

    return () => {
      clearTimeout(newTimerId); 
    };
  },[token,submit]);
  
  useEffect(() => {
    if (!token) {
      return;
    }
    const tokenDuration = getTokenDuration(token);
    const tokenRefreshInterval = setInterval(() => {
      if (token) {
        dispatch(RefreshToken(authState.userInfo));
      }
    }, tokenDuration - 10 * 60 * 1000);
    
    return () => {
      clearInterval(tokenRefreshInterval);
    };
  }, [token]);
  return (
    <>
      <Header homeUrl={"/Systems"} items={[]} />
      {!isMobile && role === Constants.RoleSystemTeam ?
      <SidebarMenu
        menuItems={getmenudata()}
      /> : ""}
      <main>
        {isMobile && role === Constants.RoleSystemTeam ? (
          <SupportBodyContent
          body={message}
        />
        ) : (
          <Outlet/>
        )}
      </main>
      <Footer item={[]}/>
      <ModalDialog 
        open={open}
        handleClose={handleClose}
        width={"xl"}
        hideBackdrop={false}
        fullScreen={true}
        body={<ModalDialog
          open={true}
          handleClose={handleClose}
          width={"xs"}
          hideBackdrop={true}
          bgColor={'#f1f1f1'}
          body={
          <>
            {!isForget && <SystemsLogin show={isForget} setshow={setisForget} handleClose={handleClose} />}
            {isForget && <ForgetPassword show={isForget} setshow={setisForget} />}
          </>
        }
        />}
      />
    </>
  );
}

export default SupportLayout;